import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const teamtailor = defineConnector({
  identifier: "teamtailor",
  name: "Teamtailor",
  tagLine: "Employer branding and recruiting",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () =>
    "https://api\\.teamtailor\\.com/.*|https://api\\.na\\.teamtailor\\.com/.*|https://api\\.au\\.teamtailor\\.com/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: `token=${app.secret.apiKey}`,
        scheme: "Token",
      },
    ]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Teamtailor, go to **Settings › Integrations › API Keys** and create a new key. See the [API docs](https://docs.teamtailor.com/) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.teamtailor.com/v1/jobs",
  },
});
